var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view'),_c('v-row',{staticClass:"m-4"},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12","md":"12"}},[_c('h4',[_vm._v(" Actualmente estás desconectado. Tus respuestas se guardarán cuando vuelvas a estar en línea. no cambies de página, cada 10 segundos intentaremos reconectar automáticamente... ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }